/**
 * Capitalize the first letter of a string.
 * @param string - The string to capitalize.
 * @returns The capitalized string.
 */
export const capitalize = (string) => (string.charAt(0).toUpperCase() + string.slice(1));
